module.exports = fox._r("fonts/robotocondensed-italic-webfont.woff2", __webpack_public_path__ + "_/_/_/root/fonts/3KWVfPf.woff2");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/robotocondensed-italic-webfont.woff2
// module id = 160
// module chunks = 4